/**
 * API Keys management slice.
 * Leaf module (Perf 3.1.b/e Step 6). Pulls only the shared chokepoint from
 * ./client; never imports a sibling @/lib/api slice.
 */
import { fetchWithAuth, ApiError } from './client';

export const apiKeysApi = {
  // List all API keys for the current user
  list: async () => {
    const data = await fetchWithAuth('/json/api-keys');

    if (data.error) {
      throw new ApiError(data.message || 'Failed to fetch API keys', 400, data);
    }

    // Also filter older server responses during a rolling deployment. Internal
    // Work keys must never appear as developer keys or consume the UI quota.
    const keys = data.data?.apiKeys || data.apiKeys || data.data || [];
    return Array.isArray(keys) ? keys.filter(key =>
      !key.key?.startsWith('gabt_') && !key.workCreditReservationId
    ) : [];
  },

  // Create a new API key
  create: async (name = null) => {
    const body = {};
    if (name) {
      body.name = name;
    }

    const data = await fetchWithAuth('/json/api-keys', {
      method: 'POST',
      body
    });

    if (data.error) {
      throw new ApiError(data.message || data.error || 'Failed to create API key', 400, data);
    }

    // Backend returns: { success, data: { apiKey: {...} } }
    // Return the apiKey object directly for the modal
    return data.data?.apiKey || data.apiKey || data.data || data;
  },

  // Revoke/delete an API key
  revoke: async (keyId) => {
    const data = await fetchWithAuth(`/json/api-keys/${keyId}`, {
      method: 'DELETE'
    });

    if (data.error) {
      throw new ApiError(data.message || data.error?.message || 'Failed to revoke API key', 400, data);
    }

    return data;
  }
};
